<template>
    <breeze-authenticated-layout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                Internal
            </h2>
        </template>

        <breeze-page :submenus="subMenus">

            <slot></slot>
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import BreezePage from '@/Components/Page'
import {hasAnyRole} from "../../../Utils/checkPermission";

export default {
    components: {
        BreezeAuthenticatedLayout,
        BreezePage
    },
    data() {
        return {
            subMenus: [
                {
                    'title': 'Leads',
                    'active': route().current('internal.lead.*'),
                    'route': route('internal.lead.list', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Enquiry')
                },
                {
                    'title': 'Enquiries',
                    'active': route().current('internal.enquiry.*'),
                    'route': route('internal.enquiry.list', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Enquiry')
                },
                {
                    'title': 'Admissions',
                    'active': route().current('internal.admission.*'),
                    'route': route('internal.admission.list', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Admission')
                },
                {
                    'title': 'Week Schedule',
                    'active': route().current('internal.weekschedule.*'),
                    'route': route('internal.weekschedule.list', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Schedule' || permission.name === 'Edit Schedule' || permission.name === 'View Schedule')
                },
                {
                    'title': 'Courses',
                    'active': route().current('internal.courseyear.*'),
                    'route': route('internal.courseyear.list', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Branch Course' || permission.name === 'Edit Branch Course' || permission.name === 'View Branch Course')
                },
                {
                    'title': 'Workshops',
                    'active': route().current('internal.workshop.*'),
                    'route': route('internal.workshop.list', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Workshop' || permission.name === 'Edit Workshop' || permission.name === 'View Workshop')
                },
                {
                    'title': 'Expenses',
                    'active': route().current('internal.expense.*'),
                    'route': route('internal.expense.list', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Expense' || permission.name === 'Edit Expense' || permission.name === 'View Expense')
                },
                {
                    'title': 'Collection',
                    'active': route().current('internal.collection.*'),
                    'route': route('internal.collection.list', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission =>
                        permission.name === 'Create Collection' ||
                        permission.name === 'Edit Collection' ||
                        permission.name === 'View Collection'
                    )
                },
                {
                    'title': 'Regenerate ID',
                    'active': route().current('internal.regenerate.*'),
                    'route': route('internal.regenerate.list', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission =>
                        permission.name === 'Edit RegenerateIDCard' ||
                        permission.name === 'View RegenerateIDCard'
                    )
                },
                {
                    'title': 'Certificates',
                    'active': route().current('internal.generate-certificates.*'),
                    'route': route('internal.generate-certificates.index', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission =>
                        permission.name === 'Create Certificate' ||
                        permission.name === 'View Certificate'
                    )
                },
                {
                    'title': "Bulk ID's",
                    'active': route().current('internal.bulkIds.download'),
                    'route': route('internal.bulkIds.download', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Bulk IDS')
                },
                {
                    'title': 'KT Students',
                    'active': route().current('internal.kt-students'),
                    'route': route('internal.kt-students', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission =>
                        permission.name === 'View KT Students' ||
                        permission.name === 'Edit KT Students'
                    )
                },
                {
                    'title': 'Result & Certificate',
                    'active': route().current('internal.result-and-certificates.*'),
                    'route': route('internal.result-and-certificates.index', localStorage.branchId),
                    'visible': hasAnyRole('Result & Certificate')
                },
                {
                    'title': 'Holidays',
                    'active': route().current('internal.holidays.*'),
                    'route': route('internal.holidays.index', localStorage.branchId),
                    'visible': hasAnyRole('Branch Holiday')
                },
                {
                    'title': 'Setting',
                    'active': route().current('internal.settings.*'),
                    'route': route('internal.settings.index', localStorage.branchId),
                    'visible': this.$page.props.auth.user.role.permissions.find(permission =>
                        permission.name === 'Create Setting' ||
                        permission.name === 'View Setting'
                    )
                },
                {
                    'title': 'Resources',
                    'active': route().current('internal.resource.*'),
                    'route': route('internal.resource.list', localStorage.branchId),
                    'visible': this.hasBranchAccess()
                },
                {
                    'title': 'University Marking',
                    'active': route().current('internal.university-marking.*'),
                    'route': route('internal.university-marking.list', localStorage.branchId),
                    'visible': this.hasBranchAccess()
                },
            ],
        }
    },
    methods: {
        hasAnyRole,
        hasBranchAccess() {
            return Boolean(this.$page.props.auth.user.branch_id) || this.$page.props.auth.user.role?.type === 'super' || this.$page.props.auth.user.role?.name === 'Super Admin';
        },
    },
}
</script>
